<template>
  <el-dialog width="50%" class="dialog" custom-class="edit-old-valuation-dialog" :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
    <el-form ref="ruleForm" label-position="right" :model="formData" label-width="140px" :rules="rules">
      <!-- 计价方式 -->
      <el-form-item label="计价方式" prop="pricingMode">
        <el-radio-group v-model="formData.pricingMode" @change="handlePricingModeChange">
          <el-radio label="WEIGHT">按重量</el-radio>
          <el-radio label="SETS">按套数</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 销司名称 -->
      <el-form-item label="销司名称" prop="salesCompanyCode">
        <el-select v-model="formData.salesCompanyCode" placeholder="请选择" style="width: 100%">
          <el-option v-for="item in salesCompanyOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>

      <!-- 品类 -->
      <el-form-item label="品类" prop="category">
        <el-select v-model="formData.category" placeholder="请选择" style="width: 100%">
          <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>

      <!-- 匹数(按套数时显示) -->
      <el-form-item label="匹数" prop="horsepower" v-if="formData.pricingMode === 'SETS'">
        <el-select v-model="formData.horsepower" placeholder="请选择" style="width: 100%">
          <el-option v-for="item in horsePowerOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>

      <!-- 品牌(按套数时显示) -->
      <el-form-item label="品牌" prop="brand" v-if="formData.pricingMode === 'SETS'">
        <el-select v-model="formData.brand" placeholder="请选择" style="width: 100%">
          <el-option label="格力" :value="1"></el-option>
          <el-option label="非格力" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <!-- 铜管 -->
      <el-form-item label="铜管" prop="hasCopperPipe">
        <el-select v-model="formData.hasCopperPipe" placeholder="请选择" style="width: 100%">
          <el-option label="含铜管" value="YES"></el-option>
          <el-option label="不含铜管" value="NO"></el-option>
        </el-select>
      </el-form-item>

      <!-- 单双片(按重量时显示) -->
      <el-form-item label="单双片" prop="panelType" v-if="formData.pricingMode === 'WEIGHT'">
        <el-select v-model="formData.panelType" placeholder="请选择" style="width: 100%">
          <el-option label="单片" value="SINGLE"></el-option>
          <el-option label="双片" value="DOUBLE"></el-option>
        </el-select>
      </el-form-item>

      <!-- 价格 -->
      <el-form-item label="价格" prop="price">
        <el-input v-model="formData.price" placeholder="请输入" clearable @input="val => onInput(val, 'price')">
          <template slot="append">{{ formData.pricingMode === 'WEIGHT' ? '元/kg' : '元/套' }}</template>
        </el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { savePriceDisplay, updatePriceDisplay, getSalesCompanies } from '@/api/oldValuation'

export default {
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      dialogMode: 'edit', // edit或add
      formData: {
        pricingMode: 'WEIGHT', // 默认按重量
        salesCompanyCode: null,
        category: null,
        horsepower: null,
        brand: null,
        hasCopperPipe: null,
        panelType: null,
        price: null
      },
      btnLoading: false,
      _isInitializing: false, // 编辑回显时跳过watcher中的清空逻辑
      // 销司枚举（动态获取）
      salesCompanyOptions: [],
      // 品类枚举
      categoryOptions: [
        { label: '柜机', value: 'CABINET' },
        { label: '挂机', value: 'WALL_MOUNT' }
      ],
      // 匹数选项(根据品类联动)
      horsePowerOptions: [],
      rules: {
        pricingMode: [{ required: true, message: '请选择计价方式', trigger: 'change' }],
        salesCompanyCode: [{ required: true, message: '请选择销司名称', trigger: 'change' }],
        category: [{ required: true, message: '请选择品类', trigger: 'change' }],
        horsepower: [{ required: true, message: '请选择匹数', trigger: 'change' }],
        brand: [{ required: true, message: '请选择品牌', trigger: 'change' }],
        hasCopperPipe: [{ required: true, message: '请选择铜管', trigger: 'change' }],
        panelType: [{ required: true, message: '请选择单双片', trigger: 'change' }],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          { validator: this.validatePrice, trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    dialogTitle() {
      return this.dialogMode === 'add' ? '新增回收价格' : '修改回收价格'
    }
  },
  watch: {
    dialogFormVisible: function(val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields()
      }
    },
    // 品类变化时更新匹数选项
    'formData.category': function(val) {
      if (val === 'CABINET') {
        // 柜机: 2P 3P 5P
        this.horsePowerOptions = [
          { label: '2P', value: '2P' },
          { label: '3P', value: '3P' },
          { label: '5P', value: '5P' }
        ]
      } else if (val === 'WALL_MOUNT') {
        // 挂机: 1P 1.5P 2P 3P
        this.horsePowerOptions = [
          { label: '1P', value: '1P' },
          { label: '1.5P', value: '1.5P' },
          { label: '2P', value: '2P' },
          { label: '3P', value: '3P' }
        ]
      } else {
        this.horsePowerOptions = []
      }
      // 切换品类时清空匹数（编辑回显初始化时跳过）
      if (!this._isInitializing) {
        this.formData.horsepower = null
      }
    }
  },
  mounted() {
    this.fetchSalesCompanies()
  },
  methods: {
    // 获取销司枚举
    async fetchSalesCompanies() {
      const res = await getSalesCompanies()
      if (res.statusCode == 200 && Array.isArray(res.data)) {
        this.salesCompanyOptions = res.data.map(item => ({
          label: item.name,
          value: item.code
        }))
      }
    },
    validatePrice(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入价格'))
      }
      const numValue = parseFloat(value)
      if (isNaN(numValue) || numValue <= 0) {
        callback(new Error('价格必须大于0'))
      } else if (numValue > 999999.99) {
        callback(new Error('价格必须小于等于999999.99'))
      } else {
        callback()
      }
    },
    handlePricingModeChange(val) {
      // 切换计价方式时清空相关字段
      if (val === 'WEIGHT') {
        this.formData.brand = null
        this.formData.horsepower = null
      } else {
        this.formData.panelType = null
      }
      // 重新校验表单
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate(['brand', 'horsepower', 'panelType'])
      })
    },
    onInput(value, key) {
      this.formData[key] = ('' + value)
        .replace(/[^\d.]/g, '') //将非数字和点以外的字符替换成空
        .replace(/^\./g, '') //验证第一个字符是数字而不是点
        .replace(/\.{2,}/g, '.') //出现多个点时只保留第一个
        .replace('.', '$#$') // 1、将数字的点替换成复杂字符$#$
        .replace(/\./g, '') // 2、将字符串的点直接清掉
        .replace('$#$', '.') // 3、将复杂字符再转换回点
        .replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3') //只能输入两个小数
    },
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false
    },

    // 打开弹框
    async openDialog(rowData, mode = 'edit') {
      this.dialogMode = mode
      if (mode === 'add') {
        // 新增模式,重置表单
        this.formData = {
          pricingMode: 'WEIGHT',
          salesCompanyCode: null,
          category: null,
          horsepower: null,
          brand: null,
          hasCopperPipe: null,
          panelType: null,
          price: null
        }
      } else {
        // 编辑模式,填充数据
        this._isInitializing = true
        this.formData = { ...rowData }
        this.$nextTick(() => {
          this._isInitializing = false
        })
      }
      this.dialogFormVisible = true
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.btnLoading = true
          this.saveFormDataReq()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    //新增or编辑
    async saveFormDataReq() {
      const submitData = { ...this.formData }
      let res
      if (this.dialogMode === 'add') {
        delete submitData.id
        res = await savePriceDisplay(submitData)
      } else {
        res = await updatePriceDisplay(submitData)
      }
      const { statusCode, message } = res

      if (statusCode == 200) {
        this.btnLoading = false
        this.$message.success(this.dialogMode === 'add' ? '新增成功' : '编辑成功')
        this.$emit('opera-success')
        this.dialogFormVisible = false
      } else {
        this.$message.error(message)
        this.btnLoading = false
      }
    },

    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields()
    }
  }
}
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/editOld.vue